<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('personalReport')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="info">
        <p class="title">{{$t('profitAmount')}} (Points)</p>
        <p class="value">{{ this.win_money.toFixed(2) }}</p>
        <p class="tip">{{$t('profitFormula')}}</p>
      </div>
      <div class="content">
        <div class="datalist">
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.play_money }}</div>
            <div class="datalistitemKey">{{$t('taskAmount')}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.recharge}}</div>
            <div class="datalistitemKey">{{$t('infomation.recharge')}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.withdrawal }}</div>
            <div class="datalistitemKey">{{$t('withdraw.title')}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
          <div class="datalistitem">
            <div class="datalistitemValue">{{ this.personalreport.win_money }}</div>
            <div class="datalistitemKey">{{$t('game.kjcc').split('，')[0]}}</div>
            <div class="datalistitemRightLine"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      win_money:0,
      personalreport:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getPersonalreport(){
      this.$http({
        method: 'get',
        url: 'user_get_personalreport'
      }).then(res=>{
        if(res.code === 200){
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getPersonalreport();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .header{
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
}
.container .header .info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
  padding-top: 10px;
  margin: auto;
}
.container .header .info .title{
  font-size: 25px;
  color: #e5e5e5;
}
.container .header .info .value{
  margin: 10px auto;
  color: #fff;
  font-size: 50px;
  border-bottom: 1px solid #fff;
}
.container .header .info .tip{
  font-size: 30px;
  color: #e5e5e5;
}
.container .content{
  flex: 1;
  background: #f2f2f5;
}
.container .content .datalist{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
.container .content .datalist .datalistitem{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 33.3%;
}
.container .content .datalist .datalistitem .datalistitemValue{
  color: #ff253f;
  font-size: 35px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.container .content .datalist .datalistitem .datalistitemKey{
  color: #979799;
  font-size: 25px;
  margin-bottom: 10px;
  margin-top: 10px;
}

@media (max-width: 430px) {
  .container.page {
    width: 100%;
    min-width: 0;
    min-height: 100svh;
    overflow-x: hidden;
  }

  .container .nav-bar {
    height: auto;
    min-height: 56px;
    padding-top: env(safe-area-inset-top);
  }

  .container .nav-bar ::v-deep .van-nav-bar__content {
    min-height: 56px;
  }

  .container .nav-bar ::v-deep .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .container .header .info {
    padding: 14px 16px 20px;
  }

  .container .header .info .title,
  .container .header .info .tip {
    max-width: 100%;
    line-height: 1.4;
    text-align: center;
    overflow-wrap: anywhere;
  }

  .container .header .info .title {
    font-size: 16px;
  }

  .container .header .info .value {
    max-width: 100%;
    margin: 10px auto;
    font-size: clamp(28px, 10vw, 42px);
    line-height: 1.2;
    overflow-wrap: anywhere;
  }

  .container .header .info .tip {
    font-size: 15px;
  }

  .container .content .datalist .datalistitem {
    width: 50%;
    min-width: 0;
    height: auto;
    min-height: 118px;
    padding: 14px 8px;
    border-bottom: 1px solid rgba(126, 86, 120, .12);
  }

  .container .content .datalist .datalistitem .datalistitemValue,
  .container .content .datalist .datalistitem .datalistitemKey {
    max-width: 100%;
    margin: 4px 0;
    line-height: 1.3;
    text-align: center;
    overflow-wrap: anywhere;
  }

  .container .content .datalist .datalistitem .datalistitemValue {
    font-size: 20px;
  }

  .container .content .datalist .datalistitem .datalistitemKey {
    font-size: 14px;
  }
}
</style>
